import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1, 0)
  },
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: theme.spacing(0.5)
  },
  button: {
    color: theme.palette.text.primary,
    padding: '12px 16px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0.5,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium,
    borderRadius: theme.spacing(1),
    transition: 'all 0.3s ease',
    fontSize: '0.95rem',
    '&:hover': {
      backgroundColor: 'rgba(102, 126, 234, 0.1)',
      transform: 'translateX(4px)',
      '& $icon': {
        color: theme.palette.primary.main,
        transform: 'scale(1.1)'
      }
    }
  },
  icon: {
    color: theme.palette.text.secondary,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2),
    transition: 'all 0.3s ease'
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    backgroundColor: 'rgba(102, 126, 234, 0.15)',
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    paddingLeft: '13px',
    '&:hover': {
      backgroundColor: 'rgba(102, 126, 234, 0.2)'
    },
    '& $icon': {
      color: theme.palette.primary.main
    }
  }
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
));

const SidebarNav = (props) => {
  const { pages, className, ...rest } = props;
  const classes = useStyles();
  return (
    <List {...rest} className={clsx(classes.root, className)}>
      {pages.map((page) => {
        const configBtn = page.onClick
          ? {
              onClick: page.onClick
            }
          : {
              to: page.href,
              component: CustomRouterLink
            };
        return (
          <ListItem className={classes.item} disableGutters key={page.title}>
            <Button
              activeclassname={classes.active}
              className={classes.button}
              {...configBtn}
            >
              <div className={classes.icon}>{page.icon}</div>
              {page.title}
            </Button>
          </ListItem>
        );
      })}
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired
};

export default SidebarNav;
